import styled from '@emotion/styled';

export const BackButtonContainer = styled.button<{ isPrimary: boolean }>`
    position: relative;
    outline: none;
    background-color: ${({ theme, isPrimary }) =>
        isPrimary ? theme.feature.buttonMain.background : theme.base.color.backgroundMain};
    border: none;
    box-sizing: border-box;
    height: 40px;
    width: 40px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;

    cursor: pointer;

    &:active {
        transform: scale(0.95);
    }

    transition: 0.1s ease;
`;
